import { motion } from 'framer-motion';
import { HiPlay, HiSparkles } from 'react-icons/hi2';
import GlitchText from './ui/GlitchText';
import Lightning from './ui/Lightning';
import Particles from './ui/Particles';
import GeometricShapes from './ui/GeometricShapes';
import Button from './ui/Button';

// Platform badges configuration with precise positioning
const platformBadges = [
  {
    name: 'Spotify',
    color: '#1DB954',
    url: 'https://open.spotify.com/artist/3qb1YMxzLPO7HZnQowycUj',
    icon: (
      <svg viewBox="0 0 24 24" fill="currentColor" className="w-5 h-5">
        <path d="M12 0C5.4 0 0 5.4 0 12s5.4 12 12 12 12-5.4 12-12S18.66 0 12 0zm5.521 17.34c-.24.359-.66.48-1.021.24-2.82-1.74-6.36-2.101-10.561-1.141-.418.122-.779-.179-.899-.539-.12-.421.18-.78.54-.9 4.56-1.021 8.52-.6 11.64 1.32.42.18.479.659.301 1.02zm1.44-3.3c-.301.42-.841.6-1.262.3-3.239-1.98-8.159-2.58-11.939-1.38-.479.12-1.02-.12-1.14-.6-.12-.48.12-1.021.6-1.141C9.6 9.9 15 10.561 18.72 12.84c.361.181.54.78.241 1.2zm.12-3.36C15.24 8.4 8.82 8.16 5.16 9.301c-.6.179-1.2-.181-1.38-.721-.18-.601.18-1.2.72-1.381 4.26-1.26 11.28-1.02 15.721 1.621.539.3.719 1.02.419 1.56-.299.421-1.02.599-1.559.3z"/>
      </svg>
    ),
    delay: 0.8,
  },
  {
    name: 'Apple Music',
    color: '#FC3C44',
    url: 'https://music.apple.com/us/artist/white-rabbit-bangers/1859082521',
    icon: (
      <svg viewBox="0 0 24 24" fill="currentColor" className="w-5 h-5">
        <path d="M23.994 6.124a9.23 9.23 0 00-.24-2.19c-.317-1.31-1.062-2.31-2.18-3.043a5.022 5.022 0 00-1.877-.726 10.496 10.496 0 00-1.564-.15c-.04-.003-.083-.01-.124-.013H5.986c-.152.01-.303.017-.455.026-.747.043-1.49.123-2.193.4-1.336.53-2.3 1.452-2.865 2.78-.192.448-.292.925-.363 1.408-.056.392-.088.785-.1 1.18 0 .032-.007.062-.01.093v12.223c.01.14.017.283.027.424.05.815.154 1.624.497 2.373.65 1.42 1.738 2.353 3.234 2.801.42.127.856.187 1.293.228.555.053 1.11.06 1.667.06h11.03c.525 0 1.048-.034 1.57-.1.823-.106 1.597-.35 2.296-.81a5.046 5.046 0 001.88-2.207c.186-.42.293-.87.37-1.324.113-.675.138-1.358.137-2.04-.002-3.8 0-7.595-.003-11.393zm-6.423 3.99v5.712c0 .417-.058.827-.244 1.206-.29.59-.76.962-1.388 1.14-.35.1-.706.157-1.07.173-.95.042-1.8-.6-1.965-1.483-.18-.965.39-1.927 1.343-2.217.428-.13.872-.2 1.314-.257.404-.053.81-.1 1.2-.19.265-.063.373-.186.38-.466.004-.085 0-.17 0-.255V8.498c0-.2-.054-.254-.253-.224-.473.07-.946.143-1.42.214l-4.09.617c-.067.01-.134.025-.2.04-.122.03-.184.107-.19.233-.003.063 0 .127 0 .19v7.79c0 .282-.014.56-.09.832-.22.793-.755 1.303-1.5 1.554-.353.118-.72.18-1.09.21-.934.075-1.808-.483-2.063-1.346-.265-.892.13-1.856 1.003-2.293.32-.16.664-.255 1.018-.306.466-.066.933-.12 1.4-.188.305-.045.467-.212.49-.515.004-.062.002-.125.002-.188V7.078c0-.323.086-.453.397-.51.503-.093 1.005-.19 1.508-.285l3.326-.63 2.436-.46c.32-.06.637-.13.956-.19.11-.02.168.02.2.128.015.052.02.107.02.16v4.822z"/>
      </svg>
    ),
    delay: 1.0,
  },
  {
    name: 'Amazon',
    color: '#FF9900',
    url: 'https://music.amazon.com/artists/B0G5FPTHFK/white-rabbit-bangers',
    icon: (
      <svg viewBox="0 0 448 512" fill="currentColor" className="w-5 h-5">
        <path d="M257.2 162.7c-48.7 1.8-169.5 15.5-169.5 117.5 0 109.5 138.3 114 183.5 43.2 6.5 10.2 35.4 37.5 45.3 46.8l56.8-56S341 288.9 341 261.4V114.3C341 89 316.5 32 228.7 32 140.7 32 94 87 94 136.3l73.5 6.8c16.3-49.5 54.2-49.5 54.2-49.5 40.7-.1 35.5 29.8 35.5 69.1zm0 86.8c0 80-84.2 68-84.2 17.2 0-47.2 50.5-56.7 84.2-57.8v40.6zm136 163.5c-7.7 10-70 67-174.5 67S34.2 408.5 9.7 379c-6.8-7.7 1-11.3 5.5-8.3C88.5 415.2 203 488.5 387.7 401c7.5-3.7 13.3 2 5.5 12zm39.8 2.2c-6.5 15.8-16 26-21.6 31-5.5 4.5-11 4.3-8-2.3l17-34.7c2.8-6.2 4.8-12.3 4.8-17 0-6.3-7.3-12-17-12H368c-6.5 0-10-4-6.5-8.3 9.3-11.5 24-13.5 35-13.5 17.5 0 54.5 6.3 54.5 38.3 0 8-3.5 13.5-18 18.5z"/>
      </svg>
    ),
    delay: 1.2,
  },
  {
    name: 'Tidal',
    color: '#00FFFF',
    url: 'https://tidal.com/artist/70876723',
    icon: (
      <svg viewBox="0 0 24 24" fill="currentColor" className="w-5 h-5">
        <path d="M12.012 3.992L8.008 7.996 4.004 3.992 0 7.996 4.004 12l4.004-4.004L12.012 12l4.004-4.004L20.02 12l4.004-4.004-4.004-4.004-4.004 4.004-4.004-4.004zM12.012 12.004l-4.004 4.004 4.004 4.004 4.004-4.004-4.004-4.004z"/>
      </svg>
    ),
    delay: 1.4,
  },
];

// Floating platform badge component with strategic positioning
const PlatformBadge = ({ 
  platform, 
  index 
}: { 
  platform: typeof platformBadges[0]; 
  index: number;
}) => {
  // Position badges around the character in a visually balanced way
  const getPositionClasses = () => {
    switch(index) {
      case 0: // Spotify - top left
        return 'left-0 top-[18%] -translate-x-[70%] md:-translate-x-[85%]';
      case 1: // Apple Music - top right
        return 'right-0 top-[18%] translate-x-[70%] md:translate-x-[85%]';
      case 2: // Amazon - bottom left
        return 'left-0 bottom-[28%] -translate-x-[60%] md:-translate-x-[75%]';
      case 3: // Tidal - bottom right
        return 'right-0 bottom-[28%] translate-x-[60%] md:translate-x-[75%]';
      default:
        return '';
    }
  };

  return (
    <motion.a
      href={platform.url}
      target="_blank"
      rel="noopener noreferrer"
      className={`absolute z-20 ${getPositionClasses()}`}
      initial={{ opacity: 0, scale: 0, x: index % 2 === 0 ? -30 : 30 }}
      animate={{ 
        opacity: 1, 
        scale: 1, 
        x: 0,
        y: [0, -6, 0],
      }}
      transition={{ 
        opacity: { delay: platform.delay, duration: 0.5 },
        scale: { delay: platform.delay, duration: 0.5, type: 'spring', stiffness: 200 },
        x: { delay: platform.delay, duration: 0.5 },
        y: { delay: platform.delay + 0.5, duration: 2.5 + index * 0.3, repeat: Infinity, ease: 'easeInOut' },
      }}
      whileHover={{ 
        scale: 1.12,
        transition: { duration: 0.2 }
      }}
      whileTap={{ scale: 0.95 }}
    >
      <div className="relative group cursor-pointer">
        {/* Glow effect */}
        <div 
          className="absolute inset-0 rounded-2xl blur-xl opacity-50 group-hover:opacity-80 transition-opacity duration-300"
          style={{ backgroundColor: platform.color }}
        />
        
        {/* Badge container */}
        <div 
          className="relative flex items-center gap-2 px-3 py-2 md:px-4 md:py-2.5 rounded-2xl border backdrop-blur-xl transition-all duration-300 group-hover:border-opacity-100"
          style={{
            background: `linear-gradient(135deg, rgba(10,10,26,0.95) 0%, rgba(15,15,35,0.95) 100%)`,
            borderColor: `${platform.color}50`,
            boxShadow: `0 8px 32px ${platform.color}30, inset 0 1px 0 rgba(255,255,255,0.1)`,
          }}
        >
          {/* Verified checkmark */}
          <div 
            className="absolute -top-1 -right-1 w-4 h-4 md:w-5 md:h-5 rounded-full flex items-center justify-center shadow-lg"
            style={{ 
              backgroundColor: platform.color,
              boxShadow: `0 2px 8px ${platform.color}80`
            }}
          >
            <svg className="w-2.5 h-2.5 md:w-3 md:h-3 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={3}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
            </svg>
          </div>

          {/* Platform icon */}
          <div 
            className="transition-transform duration-300 group-hover:scale-110 [&>svg]:w-4 [&>svg]:h-4 md:[&>svg]:w-5 md:[&>svg]:h-5"
            style={{ color: platform.color }}
          >
            {platform.icon}
          </div>

          {/* Platform name - hidden on very small screens */}
          <span 
            className="hidden sm:block font-rajdhani font-semibold text-xs md:text-sm text-white/90 group-hover:text-white whitespace-nowrap"
          >
            {platform.name}
          </span>
        </div>

        {/* Animated pulse ring */}
        <motion.div
          className="absolute inset-0 rounded-2xl pointer-events-none"
          style={{ borderColor: platform.color }}
          animate={{
            boxShadow: [
              `0 0 0 0px ${platform.color}40`,
              `0 0 0 8px ${platform.color}00`,
            ],
          }}
          transition={{ duration: 2, repeat: Infinity, ease: 'easeOut' }}
        />
      </div>
    </motion.a>
  );
};

export default function Hero() {
  return (
    <section className="relative min-h-screen flex items-center justify-center bg-cyber-darker overflow-hidden pt-20">
      {/* Background Layers */}
      <div className="absolute inset-0 bg-gradient-to-b from-cyber-darker via-cyber-dark to-cyber-darker" />
      
      {/* Cyber Grid */}
      <div className="absolute inset-0 cyber-grid opacity-30" />
      
      {/* Particles */}
      <Particles />
      
      {/* Lightning Effects */}
      <Lightning />
      
      {/* Geometric Shapes */}
      <GeometricShapes />
      
      {/* Epic Radial Glow Behind Character - Multi-layered */}
      <div 
        className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/3 w-[1000px] h-[1000px] rounded-full opacity-40"
        style={{
          background: 'radial-gradient(circle, rgba(0, 212, 255, 0.4) 0%, rgba(139, 92, 246, 0.2) 30%, transparent 60%)',
        }}
      />
      <motion.div 
        className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/3 w-[600px] h-[600px] rounded-full"
        animate={{
          opacity: [0.2, 0.4, 0.2],
          scale: [1, 1.1, 1],
        }}
        transition={{ duration: 3, repeat: Infinity }}
        style={{
          background: 'radial-gradient(circle, rgba(0, 212, 255, 0.5) 0%, transparent 70%)',
        }}
      />

      {/* Main Content */}
      <div className="relative z-10 text-center px-4 max-w-6xl mx-auto overflow-visible">
        {/* EPIC Character Image with Platform Badges */}
        <motion.div
          className="relative mx-auto mb-4 w-[280px] h-[280px] md:w-[400px] md:h-[400px] lg:w-[480px] lg:h-[480px]"
          initial={{ opacity: 0, y: 100, scale: 0.5 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          transition={{ 
            duration: 1.2, 
            ease: [0.25, 0.46, 0.45, 0.94],
            delay: 0.2
          }}
        >
          {/* Platform Badges - Floating around character */}
          <div className="absolute inset-0 overflow-visible">
            {platformBadges.map((platform, index) => (
              <PlatformBadge key={platform.name} platform={platform} index={index} />
            ))}
          </div>

          {/* Intense glow behind character */}
          <motion.div 
            className="absolute inset-[-20%] rounded-full blur-3xl"
            animate={{
              opacity: [0.3, 0.6, 0.3],
              scale: [0.9, 1.1, 0.9],
            }}
            transition={{ duration: 4, repeat: Infinity }}
            style={{
              background: 'radial-gradient(circle, rgba(0, 212, 255, 0.6) 0%, rgba(139, 92, 246, 0.4) 40%, transparent 70%)',
            }}
          />
          
          {/* Electric ring effect */}
          <motion.div
            className="absolute inset-[-10%] rounded-full border-2 border-cyber-cyan/30"
            animate={{
              scale: [1, 1.15, 1],
              opacity: [0.3, 0.6, 0.3],
              rotate: [0, 180, 360],
            }}
            transition={{ duration: 8, repeat: Infinity, ease: 'linear' }}
          />
          <motion.div
            className="absolute inset-[-5%] rounded-full border border-cyber-purple/20"
            animate={{
              scale: [1.05, 1, 1.05],
              opacity: [0.2, 0.5, 0.2],
              rotate: [360, 180, 0],
            }}
            transition={{ duration: 6, repeat: Infinity, ease: 'linear' }}
          />
          
          {/* Character Image */}
          <motion.div
            className="relative w-full h-full flex items-center justify-center"
            animate={{
              y: [0, -10, 0],
            }}
            transition={{ duration: 4, repeat: Infinity, ease: 'easeInOut' }}
          >
            <img
              src="/images/mascot-hero.png"
              alt="White Rabbit Bangers"
              className="w-full h-full object-contain drop-shadow-[0_0_40px_rgba(0,212,255,0.5)]"
            />
          </motion.div>
          
          {/* Floating energy particles around character - deterministic positions to avoid hydration mismatch */}
          {[
            { left: 25, top: 30, duration: 2.5, xOffset: 8 },
            { left: 65, top: 25, duration: 3, xOffset: -5 },
            { left: 35, top: 60, duration: 2.8, xOffset: 10 },
            { left: 70, top: 55, duration: 3.2, xOffset: -8 },
            { left: 45, top: 40, duration: 2.2, xOffset: 6 },
            { left: 55, top: 70, duration: 2.6, xOffset: -4 },
          ].map((particle, i) => (
            <motion.div
              key={i}
              className="absolute w-2 h-2 rounded-full bg-cyber-cyan"
              style={{
                left: `${particle.left}%`,
                top: `${particle.top}%`,
              }}
              animate={{
                y: [0, -30, 0],
                x: [0, particle.xOffset, 0],
                opacity: [0, 1, 0],
                scale: [0, 1, 0],
              }}
              transition={{
                duration: particle.duration,
                repeat: Infinity,
                delay: i * 0.5,
              }}
            />
          ))}
        </motion.div>

        {/* Title with Glitch Effect */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.8 }}
        >
          <GlitchText
            text="WHITE RABBIT"
            className="text-4xl md:text-6xl lg:text-7xl font-black text-white mb-2"
          />
          <motion.h2
            className="font-orbitron text-2xl md:text-4xl lg:text-5xl font-bold bg-gradient-to-r from-cyber-cyan via-cyber-purple to-cyber-pink bg-clip-text text-transparent"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 1 }}
          >
            BANGERS
          </motion.h2>
        </motion.div>

        {/* Tagline */}
        <motion.p
          className="mt-6 text-lg md:text-xl text-white/70 font-rajdhani max-w-2xl mx-auto"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 1.2 }}
        >
          AI-powered bangers across trap, hip-hop, pop, country, rock & beyond.
          <br />
          <span className="text-cyber-cyan font-mono text-sm tracking-widest">{'>'} FOLLOW THE WHITE RABBIT_</span>
        </motion.p>

        {/* CTA Buttons */}
        <motion.div
          className="mt-8 mb-20 flex flex-col sm:flex-row items-center justify-center gap-4"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 1.4 }}
        >
          <Button
            href="#music"
            variant="primary"
            size="lg"
            icon={<HiPlay className="w-5 h-5" />}
          >
            Listen Now
          </Button>
          <Button
            href="#why-ai"
            variant="outline"
            size="lg"
            icon={<HiSparkles className="w-5 h-5" />}
          >
            Why AI Music?
          </Button>
        </motion.div>
      </div>

      {/* Scroll Indicator */}
      <motion.div
        className="absolute bottom-6 left-1/2 -translate-x-1/2 z-20"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1, y: [0, 10, 0] }}
        transition={{ 
          opacity: { delay: 2 },
          y: { duration: 1.5, repeat: Infinity }
        }}
      >
        <div className="w-6 h-10 border-2 border-cyber-cyan/50 rounded-full flex justify-center">
          <div className="w-1.5 h-3 bg-cyber-cyan rounded-full mt-2 animate-pulse" />
        </div>
      </motion.div>

      {/* Bottom Gradient Fade */}
      <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-cyber-darker to-transparent" />
    </section>
  );
}

